import { Injectable } from '@angular/core';
import { LoginData } from '../models/auth.model';
import { UserAccessModuleGrouped } from '../models/access.model';
import { environment } from '../../../environments/environment';

export interface SessionState {
  auth: LoginData;
  accessGrouped: UserAccessModuleGrouped[];
}

@Injectable({ providedIn: 'root' })
export class SessionService {
  get(): SessionState | null {
    const raw = localStorage.getItem(environment.keyStorageSession);
    return raw ? (JSON.parse(raw) as SessionState) : null;
  }

  set(state: SessionState) {
    localStorage.setItem(environment.keyStorageSession, JSON.stringify(state));
  }

  async clear() {
    localStorage.removeItem(environment.keyStorageSession);
  }

  token(): string | null {
    return this.get()?.auth?.token ?? null;
  }

  userId(): number | null {
    return this.get()?.auth?.user?.userId ?? null;
  }

  clientId(): number | null {
    return this.get()?.auth?.client?.clientId ?? null;
  }

  access(): UserAccessModuleGrouped[] {
    return this.get()?.accessGrouped ?? [];
  }
}
